import { Page } from '../models/Elements';
import { PhytosanitaryProduct } from '../models/Entities';
import dateService from '../services/DateService';
import { coreApiAxios } from './CustomAxios';

class PhytosanitaryProductApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        registerNumber?: string,
        name?: string
    ): Promise<Page<PhytosanitaryProduct>> => {
        const response = await coreApiAxios.get<Page<PhytosanitaryProduct>>('/phytosanitary-products', {
            params: { page, size, sortField, sortOrder, registerNumber, name }
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((product) => this.loadDates(product));

        return response.data;
    };

    /**
     * Loads the dates of a phytosanitary product.
     * @param product - the phytosanitary product
     */
    private loadDates(product: PhytosanitaryProduct) {
        product.inscriptionDate = dateService.transformDate(product.inscriptionDate);
        product.expiryDate = dateService.transformDate(product.expiryDate);
        product.renewalDate = dateService.transformDate(product.renewalDate);
        product.modificationDate = dateService.transformDate(product.modificationDate);
        product.saleLimitDate = dateService.transformDate(product.saleLimitDate);
    }
}

const phytosanitaryProductApi = new PhytosanitaryProductApi();
export default phytosanitaryProductApi;
